import { collection, getDocs, orderBy, query } from "firebase/firestore";
import React, { useEffect, useLayoutEffect, useState } from "react";
import PostItem from "../components/PostItem";
import { db } from "../firebase";

export default function Home() {
	const [posts, setPosts] = useState([]);

	useEffect(() => {
		async function fetchUserpost() {
			const postRef = collection(db, "listings");
			const q = query(postRef, orderBy("timestamp", "desc"));
			const querySnapshot = await getDocs(q);
			const post = [];
			querySnapshot.forEach((doc) => {
				post.push({ id: doc.id, data: doc.data() });
			});
			setPosts(post);
		}
		fetchUserpost();
	}, []);

	// console.log(posts);

	return (
		<>
			<div className="text-center rounded-md mx-auto my-4 px-6 py-4 uppercase w-full bg-gradient-to-r from-transparent via-teal-700 to-transparent">
				<h1 className="text-xl font-bold text-gray-100">
					Latest Hindi Music Reviews
				</h1>
			</div>
			<ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-6xl px-4 py-8 mx-auto">
				{posts?.map((post) => (
					<PostItem
						post={post.data}
						id={post.id}
						key={post.id}
					/>
				))}
			</ul>
		</>
	);
}
